import React from "react"
import { Button, Card, Flex, Modal, Typography } from "antd"

import { Settings2Fa } from "@src/pages/settingsSecurity/ui/settings2fa"
import { SettingsChangeEmail } from "@src/pages/settingsSecurity/ui/settingsEmail"
import { ChangePassword } from "@src/pages/settingsSecurity/ui/settingsPassword"

export const SettingsSecurityPage = () => {
  return (
    <Flex gap={32} vertical>
      <Flex
        gap={24}
        id="SETTINGS_SECURITY_CHANGE_EMAIL_BLOCK"
        style={{ borderBottom: "1px solid #E9F1EA", paddingBottom: 16 }}
        vertical
      >
        <Typography.Title level={3} style={{ margin: 0 }}>
          Change Email
        </Typography.Title>

        <SettingsChangeEmail />
      </Flex>

      <Flex
        gap={24}
        id="SETTINGS_SECURITY_CHANGE_PASSWORD_BLOCK"
        style={{ borderBottom: "1px solid #E9F1EA", paddingBottom: 16 }}
        vertical
      >
        <Typography.Title level={3} style={{ margin: 0 }}>
          Change Password
        </Typography.Title>

        <ChangePassword />
      </Flex>

      <Flex
        id="SETTINGS_SECURITY_2FA_BLOCK"
        style={{ borderBottom: "1px solid #E9F1EA", paddingBottom: 16 }}
        vertical
      >
        <Typography.Title level={3} style={{ margin: 0 }}>
          2FA
        </Typography.Title>

        <Settings2Fa />
      </Flex>
    </Flex>
  )
}
